// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* ==========================================
   LAN SCANNER - PREMIUM NETWORK DASHBOARD
========================================== */

.premium-lan-scanner {
    width: 100%;
    padding: 25px !important;
    background: linear-gradient(145deg, #111827, #0b1220);
    border: 1px solid rgba(56,189,248,.15);
    border-radius: 16px;
    color: #e2e8f0;
    box-shadow: 0 12px 35px rgba(0,0,0,.2);
    font-family: Inter, Arial, sans-serif;
}

/* HEADER */

.lan-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(148,163,184,.13);
}

.lan-heading {
    display: flex;
    align-items: center;
    gap: 13px;
}

.lan-icon {
    width: 46px;
    height: 46px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(14,165,233,.12);
    border: 1px solid rgba(56,189,248,.2);
    border-radius: 12px;
    font-size: 22px;
}

.lan-heading h4 {
    margin: 0;
    color: #f8fafc;
    font-size: 19px;
    font-weight: 700;
}

.lan-heading p {
    margin: 5px 0 0;
    color: #94a3b8;
    font-size: 11px;
}

.lan-status {
    padding: 8px 12px;
    border-radius: 20px;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .8px;
}

.lan-status span {
    display: inline-block;
    width: 7px;
    height: 7px;
    margin-right: 6px;
    border-radius: 50%;
    background: #22c55e;
}

.lan-status.idle {
    color: #38bdf8;
    background: rgba(14,165,233,.09);
}

.lan-status.scanning {
    color: #fbbf24;
    background: rgba(245,158,11,.1);
}

.lan-status.scanning span {
    background: #fbbf24;
    animation: lanPulse 1s infinite;
}

@keyframes lanPulse {
    50% { opacity: .3; }
}

/* SEARCH */

.lan-search-section {
    padding: 24px 0;
}

.lan-search-section label {
    display: block;
    margin-bottom: 10px;
    color: #94a3b8;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1px;
}

.lan-search-section .input-group {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 10px;
    padding: 7px;
    background: #080f1c;
    border: 1px solid #334155;
    border-radius: 11px;
    transition: .25s;
}

.lan-search-section .input-group:focus-within {
    border-color: #0ea5e9;
    box-shadow: 0 0 0 3px rgba(14,165,233,.12);
}

.premium-lan-scanner .input-group .form-control {
    display: block !important;
    flex: 1 1 !important;
    width: 1% !important;
    min-width: 0 !important;
    height: 44px;
    padding: 0 14px;
    background: transparent !important;
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    color: #f1f5f9 !important;
    font-size: 14px;
}

.premium-lan-scanner .form-control::placeholder {
    color: #64748b !important;
}

.lan-search-section .btn {
    flex: 0 0 auto !important;
    width: auto !important;
    min-width: 125px;
    height: 44px;
    padding: 0 20px;
    border: none;
    border-radius: 8px !important;
    background: linear-gradient(135deg,#d97706,#ea580c);
    color: white;
    font-size: 13px;
    font-weight: 700;
    transition: .25s;
}

.lan-search-section .btn:hover:not(:disabled) {
    background: linear-gradient(135deg,#f59e0b,#f97316);
    transform: translateY(-1px);
    box-shadow: 0 5px 15px rgba(249,115,22,.2);
}

.lan-search-section .btn:disabled {
    opacity: .6;
    cursor: not-allowed;
}

.lan-search-section > small {
    display: block;
    margin-top: 10px;
    color: #64748b;
    font-size: 11px;
}

/* SPINNER */

.lan-spinner {
    display: inline-block;
    width: 13px;
    height: 13px;
    margin-right: 7px;
    vertical-align: middle;
    border: 2px solid rgba(255,255,255,.3);
    border-top-color: white;
    border-radius: 50%;
    animation: lanSpin .7s linear infinite;
}

@keyframes lanSpin {
    to { transform: rotate(360deg); }
}

/* STATISTICS */

.lan-stats {
    display: grid;
    grid-template-columns: repeat(3,minmax(0,1fr));
    gap: 14px;
    margin-bottom: 23px;
}

.lan-stat-card {
    padding: 17px;
    background: #0b1423;
    border: 1px solid rgba(148,163,184,.13);
    border-radius: 11px;
    transition: .25s;
}

.lan-stat-card:hover {
    border-color: rgba(56,189,248,.35);
    transform: translateY(-2px);
}

.lan-stat-icon {
    font-size: 20px;
    margin-bottom: 12px;
}

.lan-stat-card > span {
    display: block;
    color: #64748b;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .8px;
}

.lan-stat-card > strong {
    display: block;
    margin-top: 8px;
    color: #7dd3fc;
    font-size: 25px;
    font-weight: 800;
}

.lan-stat-card > strong small {
    display: inline;
    font-size: 12px;
}

.lan-stat-card > small {
    display: block;
    margin-top: 5px;
    color: #64748b;
    font-size: 10px;
}

.lan-active-text {
    color: #4ade80 !important;
    font-size: 19px !important;
}

.lan-idle-text {
    font-size: 19px !important;
    color: #94a3b8 !important;
}

/* TABLE SECTION */

.lan-results {
    overflow: hidden;
    background: rgba(15,23,42,.65);
    border: 1px solid rgba(148,163,184,.13);
    border-radius: 12px;
}

.lan-table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 17px 18px;
    border-bottom: 1px solid rgba(148,163,184,.12);
}

.lan-table-header h5 {
    margin: 0;
    color: #f1f5f9;
    font-size: 14px;
    font-weight: 700;
}

.lan-table-header p {
    margin: 5px 0 0;
    color: #64748b;
    font-size: 11px;
}

.lan-host-count {
    padding: 7px 10px;
    color: #38bdf8;
    background: rgba(14,165,233,.1);
    border-radius: 20px;
    font-size: 9px;
    font-weight: 700;
}

/* TABLE */

.lan-table-wrapper {
    max-height: 430px;
    overflow: auto;
    scrollbar-width: thin;
    scrollbar-color: #334155 #080f1c;
}

.lan-table {
    width: 100%;
    min-width: 650px;
    margin: 0 !important;
    border-collapse: separate;
    border-spacing: 0;
    color: #e2e8f0 !important;
}

.lan-table thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    padding: 15px 13px;
    background: #111d30 !important;
    color: #94a3b8 !important;
    border-bottom: 1px solid #334155 !important;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .8px;
    white-space: nowrap;
}

.lan-table tbody td {
    padding: 13px;
    vertical-align: middle;
    background: #0b1423 !important;
    color: #cbd5e1 !important;
    border-bottom: 1px solid rgba(148,163,184,.09) !important;
    font-size: 11px;
}

.lan-table tbody tr:hover td {
    background: #142238 !important;
}

.lan-table tbody tr:last-child td {
    border-bottom: none !important;
}

.lan-row-number {
    display: inline-flex;
    width: 25px;
    height: 25px;
    align-items: center;
    justify-content: center;
    background: #17263b;
    color: #94a3b8;
    border-radius: 6px;
    font-size: 10px;
}

.lan-ip-cell {
    display: flex;
    align-items: center;
    gap: 9px;
}

.lan-device-icon {
    font-size: 15px;
}

.lan-ip-cell strong {
    color: #7dd3fc;
    font-size: 12px;
    font-weight: 700;
}

.lan-mac {
    color: #c4b5fd;
    font-family: Consolas, monospace;
    font-size: 11px;
    white-space: nowrap;
}

.lan-latency {
    display: inline-block;
    padding: 5px 9px;
    border-radius: 6px;
    font-size: 10px;
    font-weight: 700;
    white-space: nowrap;
}

.latency-low {
    color: #4ade80;
    background: rgba(34,197,94,.1);
}

.latency-medium {
    color: #fbbf24;
    background: rgba(245,158,11,.1);
}

.latency-high {
    color: #fb7185;
    background: rgba(244,63,94,.1);
}

.lan-online {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #4ade80;
    font-size: 9px;
    font-weight: 700;
}

.lan-online span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #22c55e;
    box-shadow: 0 0 7px rgba(34,197,94,.6);
}

/* EMPTY STATE */

.lan-empty {
    padding: 40px 15px;
    text-align: center;
}

.lan-empty div {
    margin-bottom: 12px;
    font-size: 32px;
}

.lan-empty strong {
    display: block;
    color: #e2e8f0;
    font-size: 13px;
}

.lan-empty p {
    margin: 7px 0 0;
    color: #64748b;
    font-size: 11px;
}

/* FOOTER */

.lan-footer {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-top: 20px;
    padding-top: 14px;
    border-top: 1px solid rgba(148,163,184,.12);
    color: #475569;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .8px;
}

/* RESPONSIVE */

@media(max-width:768px) {
    .lan-stats {
        grid-template-columns: repeat(2,minmax(0,1fr));
    }

    .lan-stat-card:last-child {
        grid-column: span 2;
    }
}

@media(max-width:576px) {
    .premium-lan-scanner {
        padding: 15px !important;
    }

    .lan-heading h4 {
        font-size: 16px;
    }

    .lan-stats {
        gap: 9px;
    }

    .lan-stat-card {
        padding: 12px;
    }

    .lan-stat-card > strong {
        font-size: 21px;
    }

    .lan-search-section .btn {
        min-width: 95px;
        padding: 0 10px;
        font-size: 11px;
    }

    .premium-lan-scanner .input-group .form-control {
        font-size: 12px;
        padding: 0 8px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiagnosticTools/LanScanner.css"],"names":[],"mappings":";AACA;;4CAE4C;;AAE5C;IACI,WAAW;IACX,wBAAwB;IACxB,qDAAqD;IACrD,sCAAsC;IACtC,mBAAmB;IACnB,cAAc;IACd,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,oBAAoB;IACpB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;AACnC;;AAEA;IACI,MAAM,WAAW,EAAE;AACvB;;AAEA,WAAW;;AAEX;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,4BAA4B;IAC5B,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,yBAAyB;IACzB,oBAAuB;IACvB,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,kCAAkC;IAClC,uBAAuB;IACvB,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,6BAA6B;IAC7B,mDAAmD;IACnD,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mDAAmD;IACnD,2BAA2B;IAC3B,0CAA0C;AAC9C;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA,YAAY;;AAEZ;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;IACtB,sCAAsC;IACtC,uBAAuB;IACvB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,KAAK,yBAAyB,EAAE;AACpC;;AAEA,eAAe;;AAEf;IACI,aAAa;IACb,8CAA8C;IAC9C,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA,kBAAkB;;AAElB;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,uCAAuC;IACvC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,SAAS;IACT,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA,UAAU;;AAEV;IACI,iBAAiB;IACjB,cAAc;IACd,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;IACzB,2CAA2C;IAC3C,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,yBAAyB;IACzB,yDAAyD;IACzD,eAAe;AACnB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA,gBAAgB;;AAEhB;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA,WAAW;;AAEX;IACI,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,2CAA2C;IAC3C,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,eAAe;;AAEf;IACI;QACI,8CAA8C;IAClD;;IAEA;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;AACJ","sourcesContent":["\n/* ==========================================\n   LAN SCANNER - PREMIUM NETWORK DASHBOARD\n========================================== */\n\n.premium-lan-scanner {\n    width: 100%;\n    padding: 25px !important;\n    background: linear-gradient(145deg, #111827, #0b1220);\n    border: 1px solid rgba(56,189,248,.15);\n    border-radius: 16px;\n    color: #e2e8f0;\n    box-shadow: 0 12px 35px rgba(0,0,0,.2);\n    font-family: Inter, Arial, sans-serif;\n}\n\n/* HEADER */\n\n.lan-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 15px;\n    padding-bottom: 20px;\n    border-bottom: 1px solid rgba(148,163,184,.13);\n}\n\n.lan-heading {\n    display: flex;\n    align-items: center;\n    gap: 13px;\n}\n\n.lan-icon {\n    width: 46px;\n    height: 46px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(14,165,233,.12);\n    border: 1px solid rgba(56,189,248,.2);\n    border-radius: 12px;\n    font-size: 22px;\n}\n\n.lan-heading h4 {\n    margin: 0;\n    color: #f8fafc;\n    font-size: 19px;\n    font-weight: 700;\n}\n\n.lan-heading p {\n    margin: 5px 0 0;\n    color: #94a3b8;\n    font-size: 11px;\n}\n\n.lan-status {\n    padding: 8px 12px;\n    border-radius: 20px;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: .8px;\n}\n\n.lan-status span {\n    display: inline-block;\n    width: 7px;\n    height: 7px;\n    margin-right: 6px;\n    border-radius: 50%;\n    background: #22c55e;\n}\n\n.lan-status.idle {\n    color: #38bdf8;\n    background: rgba(14,165,233,.09);\n}\n\n.lan-status.scanning {\n    color: #fbbf24;\n    background: rgba(245,158,11,.1);\n}\n\n.lan-status.scanning span {\n    background: #fbbf24;\n    animation: lanPulse 1s infinite;\n}\n\n@keyframes lanPulse {\n    50% { opacity: .3; }\n}\n\n/* SEARCH */\n\n.lan-search-section {\n    padding: 24px 0;\n}\n\n.lan-search-section label {\n    display: block;\n    margin-bottom: 10px;\n    color: #94a3b8;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 1px;\n}\n\n.lan-search-section .input-group {\n    display: flex !important;\n    flex-wrap: nowrap !important;\n    gap: 10px;\n    padding: 7px;\n    background: #080f1c;\n    border: 1px solid #334155;\n    border-radius: 11px;\n    transition: .25s;\n}\n\n.lan-search-section .input-group:focus-within {\n    border-color: #0ea5e9;\n    box-shadow: 0 0 0 3px rgba(14,165,233,.12);\n}\n\n.premium-lan-scanner .input-group .form-control {\n    display: block !important;\n    flex: 1 1 0% !important;\n    width: 1% !important;\n    min-width: 0 !important;\n    height: 44px;\n    padding: 0 14px;\n    background: transparent !important;\n    border: none !important;\n    outline: none !important;\n    box-shadow: none !important;\n    color: #f1f5f9 !important;\n    font-size: 14px;\n}\n\n.premium-lan-scanner .form-control::placeholder {\n    color: #64748b !important;\n}\n\n.lan-search-section .btn {\n    flex: 0 0 auto !important;\n    width: auto !important;\n    min-width: 125px;\n    height: 44px;\n    padding: 0 20px;\n    border: none;\n    border-radius: 8px !important;\n    background: linear-gradient(135deg,#d97706,#ea580c);\n    color: white;\n    font-size: 13px;\n    font-weight: 700;\n    transition: .25s;\n}\n\n.lan-search-section .btn:hover:not(:disabled) {\n    background: linear-gradient(135deg,#f59e0b,#f97316);\n    transform: translateY(-1px);\n    box-shadow: 0 5px 15px rgba(249,115,22,.2);\n}\n\n.lan-search-section .btn:disabled {\n    opacity: .6;\n    cursor: not-allowed;\n}\n\n.lan-search-section > small {\n    display: block;\n    margin-top: 10px;\n    color: #64748b;\n    font-size: 11px;\n}\n\n/* SPINNER */\n\n.lan-spinner {\n    display: inline-block;\n    width: 13px;\n    height: 13px;\n    margin-right: 7px;\n    vertical-align: middle;\n    border: 2px solid rgba(255,255,255,.3);\n    border-top-color: white;\n    border-radius: 50%;\n    animation: lanSpin .7s linear infinite;\n}\n\n@keyframes lanSpin {\n    to { transform: rotate(360deg); }\n}\n\n/* STATISTICS */\n\n.lan-stats {\n    display: grid;\n    grid-template-columns: repeat(3,minmax(0,1fr));\n    gap: 14px;\n    margin-bottom: 23px;\n}\n\n.lan-stat-card {\n    padding: 17px;\n    background: #0b1423;\n    border: 1px solid rgba(148,163,184,.13);\n    border-radius: 11px;\n    transition: .25s;\n}\n\n.lan-stat-card:hover {\n    border-color: rgba(56,189,248,.35);\n    transform: translateY(-2px);\n}\n\n.lan-stat-icon {\n    font-size: 20px;\n    margin-bottom: 12px;\n}\n\n.lan-stat-card > span {\n    display: block;\n    color: #64748b;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: .8px;\n}\n\n.lan-stat-card > strong {\n    display: block;\n    margin-top: 8px;\n    color: #7dd3fc;\n    font-size: 25px;\n    font-weight: 800;\n}\n\n.lan-stat-card > strong small {\n    display: inline;\n    font-size: 12px;\n}\n\n.lan-stat-card > small {\n    display: block;\n    margin-top: 5px;\n    color: #64748b;\n    font-size: 10px;\n}\n\n.lan-active-text {\n    color: #4ade80 !important;\n    font-size: 19px !important;\n}\n\n.lan-idle-text {\n    font-size: 19px !important;\n    color: #94a3b8 !important;\n}\n\n/* TABLE SECTION */\n\n.lan-results {\n    overflow: hidden;\n    background: rgba(15,23,42,.65);\n    border: 1px solid rgba(148,163,184,.13);\n    border-radius: 12px;\n}\n\n.lan-table-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 10px;\n    padding: 17px 18px;\n    border-bottom: 1px solid rgba(148,163,184,.12);\n}\n\n.lan-table-header h5 {\n    margin: 0;\n    color: #f1f5f9;\n    font-size: 14px;\n    font-weight: 700;\n}\n\n.lan-table-header p {\n    margin: 5px 0 0;\n    color: #64748b;\n    font-size: 11px;\n}\n\n.lan-host-count {\n    padding: 7px 10px;\n    color: #38bdf8;\n    background: rgba(14,165,233,.1);\n    border-radius: 20px;\n    font-size: 9px;\n    font-weight: 700;\n}\n\n/* TABLE */\n\n.lan-table-wrapper {\n    max-height: 430px;\n    overflow: auto;\n    scrollbar-width: thin;\n    scrollbar-color: #334155 #080f1c;\n}\n\n.lan-table {\n    width: 100%;\n    min-width: 650px;\n    margin: 0 !important;\n    border-collapse: separate;\n    border-spacing: 0;\n    color: #e2e8f0 !important;\n}\n\n.lan-table thead th {\n    position: sticky;\n    top: 0;\n    z-index: 2;\n    padding: 15px 13px;\n    background: #111d30 !important;\n    color: #94a3b8 !important;\n    border-bottom: 1px solid #334155 !important;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: .8px;\n    white-space: nowrap;\n}\n\n.lan-table tbody td {\n    padding: 13px;\n    vertical-align: middle;\n    background: #0b1423 !important;\n    color: #cbd5e1 !important;\n    border-bottom: 1px solid rgba(148,163,184,.09) !important;\n    font-size: 11px;\n}\n\n.lan-table tbody tr:hover td {\n    background: #142238 !important;\n}\n\n.lan-table tbody tr:last-child td {\n    border-bottom: none !important;\n}\n\n.lan-row-number {\n    display: inline-flex;\n    width: 25px;\n    height: 25px;\n    align-items: center;\n    justify-content: center;\n    background: #17263b;\n    color: #94a3b8;\n    border-radius: 6px;\n    font-size: 10px;\n}\n\n.lan-ip-cell {\n    display: flex;\n    align-items: center;\n    gap: 9px;\n}\n\n.lan-device-icon {\n    font-size: 15px;\n}\n\n.lan-ip-cell strong {\n    color: #7dd3fc;\n    font-size: 12px;\n    font-weight: 700;\n}\n\n.lan-mac {\n    color: #c4b5fd;\n    font-family: Consolas, monospace;\n    font-size: 11px;\n    white-space: nowrap;\n}\n\n.lan-latency {\n    display: inline-block;\n    padding: 5px 9px;\n    border-radius: 6px;\n    font-size: 10px;\n    font-weight: 700;\n    white-space: nowrap;\n}\n\n.latency-low {\n    color: #4ade80;\n    background: rgba(34,197,94,.1);\n}\n\n.latency-medium {\n    color: #fbbf24;\n    background: rgba(245,158,11,.1);\n}\n\n.latency-high {\n    color: #fb7185;\n    background: rgba(244,63,94,.1);\n}\n\n.lan-online {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #4ade80;\n    font-size: 9px;\n    font-weight: 700;\n}\n\n.lan-online span {\n    width: 7px;\n    height: 7px;\n    border-radius: 50%;\n    background: #22c55e;\n    box-shadow: 0 0 7px rgba(34,197,94,.6);\n}\n\n/* EMPTY STATE */\n\n.lan-empty {\n    padding: 40px 15px;\n    text-align: center;\n}\n\n.lan-empty div {\n    margin-bottom: 12px;\n    font-size: 32px;\n}\n\n.lan-empty strong {\n    display: block;\n    color: #e2e8f0;\n    font-size: 13px;\n}\n\n.lan-empty p {\n    margin: 7px 0 0;\n    color: #64748b;\n    font-size: 11px;\n}\n\n/* FOOTER */\n\n.lan-footer {\n    display: flex;\n    justify-content: space-between;\n    gap: 10px;\n    margin-top: 20px;\n    padding-top: 14px;\n    border-top: 1px solid rgba(148,163,184,.12);\n    color: #475569;\n    font-size: 9px;\n    font-weight: 700;\n    letter-spacing: .8px;\n}\n\n/* RESPONSIVE */\n\n@media(max-width:768px) {\n    .lan-stats {\n        grid-template-columns: repeat(2,minmax(0,1fr));\n    }\n\n    .lan-stat-card:last-child {\n        grid-column: span 2;\n    }\n}\n\n@media(max-width:576px) {\n    .premium-lan-scanner {\n        padding: 15px !important;\n    }\n\n    .lan-heading h4 {\n        font-size: 16px;\n    }\n\n    .lan-stats {\n        gap: 9px;\n    }\n\n    .lan-stat-card {\n        padding: 12px;\n    }\n\n    .lan-stat-card > strong {\n        font-size: 21px;\n    }\n\n    .lan-search-section .btn {\n        min-width: 95px;\n        padding: 0 10px;\n        font-size: 11px;\n    }\n\n    .premium-lan-scanner .input-group .form-control {\n        font-size: 12px;\n        padding: 0 8px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
